import { getId, Icon, Modal, PrimaryButton, ProgressIndicator } from '@fluentui/react';
import { StyleUtils } from '../../common/views/StyleUtils';
import { Utils } from '../../common/views/Utils';
import { UploadPictureModel } from '../models/PictureModel';
import { useAddPictureVM } from '../viewmodels/AddPictureVM';
import PictureUpload from './PictureUpload';

type AddPictureProps = {
    onSubmit: (picture: UploadPictureModel) => void;
    onClose: () => void;
}

export default function AddPictureView({ onSubmit, onClose }: AddPictureProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const vm = useAddPictureVM();

    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);

    const modalHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>Add Picture</b></div>
                <div className={width2 + " right"}>
                    <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <div className="popup-header">
                {modalHeader()}
            </div>
            <div id={subtitleId} className="popup-body">
                <PictureUpload
                    isEdit={false}
                    onAction={(file) => vm.setField("file", file)}
                    fileType={vm.form.type}
                    fileCategory={vm.form.category}
                    imageUrl={undefined}
                />

                {!vm.loading && <div className="ms-Grid-row center pt-10">
                    <PrimaryButton onClick={() => onSubmit(vm.form)}>Submit</PrimaryButton>
                </div>}

                {vm.loading && <div className="pt-20">
                    <ProgressIndicator label="Submitting" description="" />
                </div>}
            </div>
        </Modal>
    </>;
}